<script setup>
defineProps({ open: Boolean, saving: Boolean })
defineEmits(['cancel', 'discard', 'save'])
</script>

<template>
  <div v-if="open" class="annotation-confirm-layer">
    <section class="annotation-confirm" role="alertdialog" aria-modal="true" aria-labelledby="annotation-exit-title">
      <small>ANNOTATION</small>
      <h2 id="annotation-exit-title">退出标注编辑？</h2>
      <p>是否保存本次标注修改？</p>
      <footer>
        <button type="button" :disabled="saving" @click="$emit('cancel')">取消</button>
        <button class="is-danger" type="button" :disabled="saving" @click="$emit('discard')">不保存</button>
        <button class="is-primary" type="button" :disabled="saving" @click="$emit('save')">{{ saving ? '保存中…' : '保存并退出' }}</button>
      </footer>
    </section>
  </div>
</template>
